import React from 'react';
import { useNavigate } from "react-router-dom";
import "../../styles/support/about_us.css";

const AboutUs = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };
    
    return(
        <div className="about_us_screen">
            <div className="contact_us_screen_header_con">
                <p className="contact_us_screen_header">About Movinity</p>
                <p onClick={goBack} className="home_view_discussions_back">back</p>
            </div>

            <div className="contact_us_screen_divider"></div>

            <div className="about_us_screen_content">
                <p className="about_us_screen_content_p">
                    {/* Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's 
                    standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make 
                    a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, 
                    remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing 
                    Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of 
                    Lorem Ipsum. t is a long established fact that a reader will be distracted by the readable content of a page when 
                    looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, 
                    as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing 
                    packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover 
                    many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on 
                    purpose (injected humour and the like). */}
                </p>

                <p className='about_us_screen_sub_head'>👋 Welcome to Movinity — Where Stories Connect Us</p>
                <p className='about_us_screen_sub_text'>
                    Movinity is more than just a movie and series database — it’s a living, breathing community 
                    built for film and TV enthusiasts. <br/>Whether you're a casual binge-watcher or a devoted cinephile, 
                    Movinity gives you the space to discover, save, discuss, and vote on your favorite movies and 
                    shows. From blockbuster hits to hidden gems, you can dive into detailed information, explore 
                    trending titles, or revisit timeless classics — all in one sleek, interactive platform.
                </p>

                <p className='about_us_screen_sub_head'>🔍 Discover & Explore</p>
                <p className='about_us_screen_sub_text'>
                    Every great film or series deserves the spotlight.
                    <br/>Browse our extensive web application across all genres and eras, filled with rich metadata, 
                    homepages, images, ratings, and more. Find new releases, rediscover old favorites, and stumble 
                    upon cult classics you never knew you needed.
                </p>

                <p className='about_us_screen_sub_head'>📚 Save and Organize</p>
                <p className='about_us_screen_sub_text'>
                    Tired of forgetting what you wanted to watch?
                    <br/>With Movinity, you can easily save and organize movies and TV series into your personal 
                    or public collections. Keep track of your current watchlist, bookmark upcoming releases, 
                    and save already watched items — all from one central place.
                </p>

                <p className='about_us_screen_sub_head'>💬 Engage in Conversations</p>
                <p className='about_us_screen_sub_text'>
                    Movies and shows spark conversation — and we give you the space to have them.
                    <br/>Join topic-driven discussions, comment on individual titles, and share your theories, 
                    reviews, or hot takes. Whether you're dissecting a season finale or debating the best director 
                    of the decade, there’s always someone ready to chat.
                </p>

                <p className='about_us_screen_sub_head'>⭐ Vote</p>
                <p className='about_us_screen_sub_text'>
                    Nominate a movie or series for the best genre in their category.
                    <br/>Whether it’s a gripping drama, a mind-bending sci-fi, or a laugh-out-loud comedy, your 
                    picks help shape the community’s favorites. Vote on your top titles, see how they stack up 
                    against the competition, and discover what other fans are loving too. Your voice matters — let 
                    it be heard in the ultimate celebration of film and television.
                </p>

                <p className='about_us_screen_sub_head'>🔐 Private Messaging</p>
                <p className='about_us_screen_sub_text'>
                    Some conversations need a little privacy.
                    <br/>Our built-in messaging feature lets you have meaningful one-on-one chats with fellow 
                    users — whether you're swapping reviews, sharing niche favorites, or just checking in after the 
                    latest episode drop.
                </p>

                <p className='about_us_screen_sub_head'>❤️ Built for Storytellers, Viewers & Everyone In-Between</p>
                <p className='about_us_screen_sub_text'>
                    Movinity is for anyone who loves the art of storytelling — whether you're a casual viewer, 
                    a series marathoner, or a deep-diving critic. We're here to help you explore, engage, and 
                    connect through the movies and shows that bring us together.
                </p>

                <p className='about_us_screen_sub_head'>🎥 Join Movinity Today</p>
                <p className='about_us_screen_sub_text'>
                    Because every watchlist has a story, and every story brings us closer.
                </p>
            </div>
        </div>
    );
};

export default AboutUs;